<template>
  <layout-main-inner title="扫码场景">
    <layout-card-wrap hasHeaderSlot>
      <template slot="title">
        <el-button
          type="primary"
          @click="addProduct">新增场景</el-button>
      </template>
      <template slot="form">
        <el-input
          v-model="config.pageName"
          placeholder="请输入场景名称"
          clearable=""
          style="width: 200px;margin-left: 10px;"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="场景名称"
          :resizable="false">
          <template slot-scope="{row}">
            {{ row.pageName }}
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="页面名称"
          prop="pageTitle"></el-table-column>
        <el-table-column
          :resizable="false"
          label="商品数量"
          width="100"
          prop="productCount"></el-table-column>
        <el-table-column
          :resizable="false"
          label="生效时间">
          <template slot-scope="{row}">
            <template v-if="row.sceneType === 1">
              {{ row.beginTime | dateformat('YYYY-MM-DD') }} - {{ row.endTime | dateformat('YYYY-MM-DD') }}
            </template>
            <template v-else>
              长久有效
            </template>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="发布状态"
          width="120">
          <template slot-scope="{row}">
            <el-tag
              v-if="row.status===1"
              type="success">已发布</el-tag>
            <el-tag
              v-if="row.status===0"
              type="info">未发布</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column
          :resizable="false"
          label="创建时间"
          width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | dateformat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          :resizable="false"
          width="170">
          <template slot-scope="{row}">
            <el-button
              type="warning"
              @click="update(row)">编辑</el-button>
            <el-button
              type="primary"
              @click="settagscansceneproducts(row)">设置商品</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
    <!-- <add-gateway-confirm-modal ref="modal" /> -->
    <product-modal
      ref="modal"
      :callback="fetchList" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import ProductModal from './product-modal.vue'
// import AddGatewayConfirmModal from './busi/add-gateway-confirm-modal.vue'

export default {
  name: 'WxappH5List',
  components: { ProductModal },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        pageName: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.config.vendorId = this.userInfo.orgId
    this.fetchList()
  },
  methods: {
    update(row) {
      this.$router.push(`/wxapp-h5-edit?tagScanSceneId=${row.tagScanSceneId}&vendorId=${row.vendorId}`)
    },
    addProduct() {
      this.$router.push(`/wxapp-h5-edit?vendorId=${this.config.vendorId}`)
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    settagscansceneproducts(row) {
      this.$refs.modal.fetch(row)
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('gateway/gettagscanscenes', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
